export class BaseObject {
  constructor({
    id,
    type = "object",
    tool = "object",
    points,
    dotIds,
    strokeColor = "#111111",
    fillColor = "transparent",
    outlineStyle = "solid",
    lineWidth = 2,
    opacity = 1,
    visible = true,
    locked = false,
    zIndex = 0,
    dimensions = [],
    meta = {}
  } = {}) {
    const normalizedPoints = Array.isArray(points) ? points : Array.isArray(dotIds) ? dotIds : [];

    this.id = id;
    this.type = type;
    this.tool = tool;
    this.points = [...normalizedPoints];
    this.strokeColor = strokeColor;
    this.fillColor = fillColor;
    this.outlineStyle = outlineStyle;
    this.lineWidth = lineWidth;
    this.opacity = opacity;
    this.visible = visible;
    this.locked = locked;
    this.zIndex = zIndex;
    this.dimensions = Array.isArray(dimensions) ? dimensions.map((dimension) => ({ ...dimension })) : [];
    this.meta = meta;
  }
}
